<template>
	<div class="policyDe">
		<div class="policyDeCon">
			<div class="left">
				<div class="title">关于我们</div>
				<div class="text">
					<h4>01 什么是 【准聘】？</h4>
					<p>【准聘】隶属于成都三角形人力资源服务有限公司，为旗下的招聘品牌，是以互联网“直聘”模式为主的在线招聘产品。</p>
					<p>基于当下的前沿技术人工智能、大数据等，【准聘】通过稳定的技术支持和大数据分析能力，可以为企业提供更准确的招聘匹配和推荐服务，同时也可以根据用户反馈和数据分析不断优化平台上的功能和体验。</p>
				</div>
			
				<div class="text">
					<h4>02 【准聘】有什么特点？</h4>
					<p>1.创新的商业模式</p>
					<p>不同于其他招聘产品，准聘独树一帜，创新商业模式。基于公司强大的政策咨询资源，上线了政策申报服务，涵盖政策咨询、互联网、融资、供应链、营销、智慧财务，为企业和用户提供更多行业前沿政策。</p>
					<p>2.稳定的技术支持更精准</p>
					<p>准聘以“直聊+精准匹配”为产品核心，将即时通讯引入招聘场景并利用大数据和人工智能技术不断追求岗位与人才的多维度精准推荐和匹配，为用户实现求职招聘效率和效果的全面提升。</p>
					<p>3.简化的招聘流程更高效</p>
					<p>准聘基于大数据与人工智能，具备精准匹配和快速反馈机制，高效帮助企业HR与求职者各取所需，简化招聘流程帮助求职者在最短的时间内找到工作，确保招聘效果。</p>
					<p>4.移动化体验降低获取成本</p>
					<p>准聘立足移动端，涵盖PC端+APP+小程序+公众号，全方位、移动化、沉浸式招聘与找工作，让企业与用户更快速达到目的。</p>
					<p>5.海量企业与用户各取所需</p>
					<p>基于公司已有的人力资源服务业务，利用积累的企业与用户资源，准聘上线便成功邀约大量企业入驻，并获得不少待就业青年的喜爱。</p>
					<p>6.兼职+全职全覆盖</p>
					<p>随着经济的快速发展与就业市场的持续扩大，类似于遛狗员、保育员，上门厨师、保洁员等零工市场得到青睐。准聘紧跟市场动态，涵盖各类工作，为更多不同年龄不同行业的群体带来便利。</p>
					<p>7.直击招聘行业痛点</p>
					<p>目前招聘行业普遍存在：招聘渠道单一；招聘量大难度大；招聘体系不足；招聘行业竞争压力大等痛点。准聘的面世在补充招聘渠道的同时，加上本身的优势也可缓解其他行业痛点。</p>
					<p>8.精准覆盖企业需求热点</p>
					<p>准聘拥有“直聊+精准匹配”的核心，以及充足的求职用户储备，能根据企业岗位的需求，快速锁定高适合度人选推送，提高寻找效率，降低时间成本</p>
					<p>9.To B 提高面试到访有效性</p>
					<p>三角形的政策服务已涵盖65+行业，我们以专业、全面、高效的服务态度和行动深耕多年，相信不论你是哪个行业，“总有一项适合你”！</p>
					<p>10.To B 完善的政策服务体系</p>
					<p>准聘在成熟的平台机制上，全面推出融合招聘、政策服务、商业服务为一体的套餐体系，精准覆盖了目前企业用工荒、结构转型难、品牌知名度差等需求。</p>
					<p>11.To C 严格把关信息真实性</p>
					<p>针对目前市面上企业信息和求职者信息造假的乱象，准聘严格进行把关，公平、公正、公开，以尊重双方的合法权益。</p>
					<p>12.To C 提高求职成功有效性</p>
					<p>在严格把关企业、求职者双方的信息、精准匹配简历适合度，以及提高面试到访有效性的基础上，求职者应聘成功率自然会随之增加。</p>
				</div>
				
				<div class="text">
					<h4>03 准聘】与竞品平台的差异化？</h4>
					<p>除了招聘服务，【准聘】独树一帜，基于三角形10w+的中小型企业合作客户这一强大背景，上线了政策申报服务。涵盖政策咨询、互联网、融资、供应链、营销、智慧财务，为更多企业带来福利的同时，也发展成一个政策发布与汇聚的共享平台。</p>
				</div>
				
				<div class="text">
					<h4>04 【准聘】的市场前景？</h4>
					<p>历年来高校毕业生人数逐年递增，巨大的人才市场中，求职需求可见一斑。</p>
					<p>而目前招聘行业普遍存在：招聘渠道单一；招聘量大难度大；招聘体系不足；招聘行业竞争压力大等痛点</p>
					<p>【准聘】的面世及时有力地缓解了行业痛点，同时平台推出的融合招聘、政策服务、商业服务为一体的套餐体系，精准覆盖了当下企业“用工荒”、结构转型难、品牌知名度差等需求。</p>
					<p>因此无论从痛点还是需求出发，我们都在及时地做出反馈，更新平台功能，以达到为更多群体做好服务的目的。</p>
				</div>
				
				<div class="text">
					<h4>05 【准聘】可以为你带来什么？</h4>
					<p>To B：正如在前面提到的【准聘】特点里所说，对于B端用户，【准聘】可精准提高面试到访有效性，同时为企业提供完善的、配套的、合适的政策服务。</p>
					<p>To C：对于C端用户，准聘深度合作的企业高达10w+，同时有源源不断的优质企业和商家陆续入驻，C端用户可以在平台寻找全职、兼职，获取最新的职场资讯以及面试技巧等。</p>
				</div>
				
				<div class="text">
					<h4>06【准聘】的入口有哪些？</h4>
					<p>【准聘】立足移动端，涵盖PC端+APP+小程序+公众号，提供全方位、移动化、沉浸式的服务。</p>
					<div class="imgbox">
						<div class="qrcodebox">
							<img src="@/static/qrcode.jpg" class="code" />
							<div class="codetext">微信小程序</div>
						</div>
					</div>
				</div>
			</div>
			<div class="right">
				<downCode></downCode>
			</div>
		</div>
		
	</div>
</template>

<script>
	import downCode from '@/components/downCode.vue'
	export default {
		name:'aboutUs',
		components: {
			downCode
		},
		data() {
			return {
				id:'',
				detail:'',
				loading:false
			}
		},
		created() {
			
		},
		methods: {
			
		}
	}
</script>

<style lang="scss" scoped>
	.policyDe{
		position: relative;
		box-sizing: border-box;
		padding: 38px 0;
		display: flex;
		justify-content: center;
		min-height: calc(100vh - 56px - 325px);
		.policyDeCon{
			display: flex;
			margin: 0 auto;
			width: 1200px;
			position: relative;
			z-index: 2;
			.left{
				flex: 1;
				background-color: #FFF;
				.title{
					font-size: 24px;
					font-weight: bold;
					margin-bottom: 38px;
				}
				.text{
					margin-bottom: 28px;
				}
				p{
					margin-top: 12px;
					font-size: 15px;
					color: #333;
					text-align: justify;
				}
				.imgbox{
					margin-top: 28px;
					display: flex;
					.qrcodebox{
						text-align: center;
						border: 1px solid #51a190;
						padding: 12px;
						border-radius: 8px;
						.code{
							width: 140px;
							height: 140px;
						}
						.codetext{
							margin-top: 12px;
							font-size: 16px;
						}
					}
				}
			}
		}
	}
</style>